import { unixTimestamp } from '@/utils'

/**
 * 将时间戳(秒级/毫秒级)转换为年月日 时分秒格式
 *  @param {number} t
 *  @return {string}
 */

export function formatTimestamp (t) {
  if (`${t}`.length === 10) {
    return unixTimestamp(t + '000')
  } else if (`${t}`.length === 13) {
    return unixTimestamp(t)
  } else {
    return '--'
  }
}
